import React from "react";
import * as styles from "./CruiseFareInclusionsList.module.scss";

export type CruiseFareInclusionItem = {
  text: string;
  highlight: boolean;
};

export interface CruiseFareInclusionsListProps {
  renderBody: () => JSX.Element;
  title: string | JSX.Element;
  subTitle?: string | JSX.Element;
  disclaimer?: string | JSX.Element;
}

const CruiseFareInclusionsList: React.FC<CruiseFareInclusionsListProps> = ({
  renderBody,
  title,
  disclaimer = undefined,
  subTitle = undefined
}) => {
  return (
    <React.Fragment>
      {renderBody && (
        <div className={styles.container}>
          <div className={styles.titleContainer}>
            <div className={styles.title}>{title}</div>
            {subTitle && <div className={styles.subTitle}>{subTitle}</div>}
            {disclaimer && (
              <div className={styles.disclaimer}>{disclaimer}</div>
            )}
          </div>
          <div className={styles.body}>{renderBody()}</div>
        </div>
      )}
    </React.Fragment>
  );
};

export default CruiseFareInclusionsList;
